import { debounce } from 'lodash';
import { EMAIL_REGEX } from '@/utils/regex';
import { fetcher } from '@/utils/fetcher';

// We need this checks to prevent multiple email-check triggers after blurs, other form fields focus, etc.
let lastCheckedEmail = '';
let lastResolveState = true;

const resolveAndMemorize = <T>(resolve: (arg0: boolean) => T, state: boolean): T => {
    lastResolveState = state;
    return resolve(state);
};

const isEmailUnique = debounce((email: string, resolve, isStaff?: boolean) => {
    if (lastCheckedEmail === email) {
        return resolve(lastResolveState);
    }

    lastCheckedEmail = email;

    if (!EMAIL_REGEX.test(email)) {
        return resolve(true);
    }

    fetcher('/api/auth/check-email', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: email,
            is_staff: isStaff
        })
    }).then(res => res.json()).then(res => resolveAndMemorize(resolve, !res.exists));
}, 300);

export default isEmailUnique;
